import axios from 'axios';

export const apiBaseUrl = `${process.env.REACT_APP_ONLINE_URL}/api/v1`;
export const api = axios.create({
  baseURL: apiBaseUrl,
  // headers:{
  //     "Content-Type":"application/json"
  // }
});

export const getUserById = async id => {
  try {
    const { data } = await api.get(`/user/getUserById/${id}`);
    return data;
    // console.log(data);
  } catch (error) {
    return error;
  }
};

export const updateUser = async (id, body) => {
  try {
    const { data } = await api.put(`/user/updateUser/${id}`, body);
    return data;
  } catch (error) {
    return error;
  }
};

// get user by admin id for users sidebar menu
export const getUsersAddedByAdmin = async id => {
  try {
    const data = await api.get(`/user/getAllUsers/${id}`);
    console.log('/user/getAllUsers/', data);
    return data;
  } catch (error) {
    return error;
  }
};

// ROLES

// get folders in role sidbar tab

export const getAllFolders = async () => {
  try {
    const { data } = await api.get(`/role/getAllFolders`);
    console.log('role/getAllFolders', data);
    return data;
  } catch (error) {
    return error;
  }
};

// get procedures by folder
export const getProcedureByFolder = async id => {
  try {
    const { data } = await api.get(`/role/getProcedureByFolder/${id}`);
    console.log('role/getProcedureByFolder', data);
    return data;
  } catch (error) {
    return error;
  }
};

// get getPreSelectProcedures with rle id

export const getPreSelectProcedures = async id => {
  try {
    const { data } = await api.get(`/role/getPreSelectProcedures/${id}`);
    console.log('role/getPreSelectProcedures', data);
    return data;
  } catch (error) {
    return error;
  }
};
